module.exports = __webpack_public_path__ + "media/images/plugin_structure-0893951fa3a5e094b36c531423af2ba0.png";